import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { styled } from '@mui/material/styles'

/** Fixed height of the tabs bar, in pixels. Exposed so sticky elements can pin below it. */
export const TABS_HEIGHT = 48

/** Horizontal padding of a tab, in theme spacing units. */
export const TAB_PADDING_X = 2

export const StyledTab = styled(Tab)(({ theme }) => ({
  '@media (min-width: 600px)': {
    minWidth: 'unset',
  },

  '&.MuiTab-root': {
    boxSizing: 'border-box',
    position: 'relative',
    height: TABS_HEIGHT,
    minHeight: 'unset',
    minWidth: 'fit-content',
    // 12px / 16px at every width — the DS spec gives Tab Item a single
    // horizontal padding, so the strip must not widen on desktop.
    padding: theme.spacing(1.5, TAB_PADDING_X),
    textTransform: 'unset',

    '.MuiTouchRipple-child': {
      backgroundColor: 'transparent',
    },

    '.MuiTypography-root': {
      color: theme.palette.text['label-default'],
    },

    '&:hover': {
      backgroundColor: theme.palette.action['bg-hover'],
      '.MuiTypography-root': {
        color: theme.palette.text.brand,
      },
    },

    '&.Mui-selected': {
      backgroundColor: 'transparent',
      '.MuiTypography-root': {
        color: theme.palette.text.brand,
      },
    },

    '&.Mui-focusVisible': {
      '.MuiTypography-root': {
        color: theme.palette.text.brand,
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        inset: 0,
        boxSizing: 'border-box',
        border: `3px solid ${theme.palette.border.focus}`,
        borderRadius: theme.radius.sm,
        pointerEvents: 'none',
      },
    },

    // Selected + focus — lift the ring's bottom so the selected indicator stays
    // visible underneath.
    '&.Mui-focusVisible.Mui-selected::after': {
      bottom: '5px',
    },

    '&.Mui-disabled .MuiTypography-root': {
      color: theme.palette.text['label-default'],
    },
  },

  '&.MuiTab-textColorInherit': {
    opacity: 'unset',
  },
}))

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  '&.MuiTabs-root': {
    height: TABS_HEIGHT,
    minHeight: 'unset',
    width: '100%',

    '.MuiTabs-indicator': {
      height: 3,
      backgroundColor: theme.palette.text.brand,
      width: 0,
    },
  },
}))
